<!-- A lot of ngIf cause first we have to display releated products and display zippy tabs only for carousel with products -->

<div class="center wrap-x">
    @if (printedSections.length || client.isCms) {
    <h3 class="h1 p-t-5-s b-t-s b-col-42-s"
        sizeClass="XL:h1, MS:h2"
        *iCms="'title' of component; skipEmpty: true"
        [scrollNavTarget]="'Related products' | translate"></h3>
    }
    @if (component && printedSections.length || client.isCms) {
    <p class="m-t-1 p1"
       *iCms="'subtitle' of component; skipEmpty: true"></p>
    }
    <ng-container *ifSize="'SM'">
        @for (section of component.sections; track $index) {
        <div class="p-t-3 p-b-3 text"
             [zippy]="getZippyId(section)">
            @if (section.engine !== 'recent' && isSectionPrinted(section)) {
            <href [link]="section.view_all_href">
                <p class="p1 m-b-0-s"
                   *iCms="'view_all_copy' of section">
                </p>
            </href>
            }
        </div>
        }
    </ng-container>
    @if ( printedSections.length || client.isCms) {
    <div class="col-12 underline m-b-6-s m-b-6-m"
         [sizeClass]="'!S: flex flex-justify-center m-t-3'">
        @for (section of printedSections; track $index) {
        @if (isSectionPrinted(section) && hasManySections) {
        <button class="s1 product-carousel-tab m-t-2-s w-12-s"
                [zippyOpen]="getZippyId(section)"
                zippyClass="col-1">
            <span class="underline-s"
                  *iCms="'title' of section"></span>
            <div *ifSize="'!S'"
                 class="vertical-separator m-r-3 m-l-3">
            </div>
        </button>
        }
        }
    </div>
    }
    @for (section of component.sections; track $index) {
    <div [sizeClass]="'XL:m-l-6 m-r-6,SM:m-l m-r'"
         [zippy]="getZippyId(section)"
         [zippyAuto]="true">
        <ng-container *ifSize="'XL'">
            <div class="view_all text">
                @if (section.engine !== 'recent' && isSectionPrinted(section)) {
                <href [link]="section.view_all_href">
                    <p class="p1 right"
                       *iCms="'view_all_copy' of section">
                    </p>
                </href>
                }
            </div>
        </ng-container>
        <related-products class="block m-b-8"
                          [limit]="section.limit"
                          [listId]="component.id"
                          [listName]="section.title"
                          [source]="getSource(section)"
                          [klevuRecommendationId]="section.klevuRecommendationId || $any(options(section))?.options?.strategyId"
                          (isPrinted)="printSection(section, $event)"
                          [options]="options(section)">
        </related-products>
    </div>
    }
</div>